// extracted by mini-css-extract-plugin
export default {"header":"header-module--header--lCLPZ","appHeaderLogo":"header-module--app-header-logo--YoA-P"};